export enum SecondFactorMethod {
    TOTP = 1,
    U2F = 2,
    MobilePush = 3,
}
